// 모바일 헤더 따로 들어가는 경우 :  meta: { mobileHd: true },
// 모바일 헤더에 찜하기 버튼 있는 경우 : meta: { likeBtn: true },
const mainRoutes = [
  {
    path: "main",
    name: "clientMain",
    meta: {
      title: "메인",
      titleEn: "Home",
      mobileTitle: "메인",
      gnbBtn: true,
      mode: "biz",
    },
    component: () => import("@/views/main/LandingPage.vue"),
  },
  {
    path: "integration-guide",
    name: "integrationGuide",
    meta: {
      title: "연동 가이드",
      titleEn: "Integration Guide",
      mobileTitle: "연동 가이드",
      gnbBtn: true,
      mode: "biz",
    },
    component: () => import("@/views/guide/DiagExtTestPage.vue"),
  },
  {
    path: "integration-guide2",
    name: "integrationGuide2",
    meta: {
      title: "연동 가이드2",
      titleEn: "External Integration Guide2",
      mobileTitle: "연동 가이드2",
      gnbBtn: true,
      mode: "dev",
    },
    component: () => import("@/views/guide/DiagExtTestPage.vue"),
  },
  {
    path: "ext-guide",
    name: "apiGuide",
    meta: {
      title: "API 가이드",
      titleEn: "API Guide",
      mobileTitle: "API 가이드",
      gnbBtn: true,
      mode: "biz",
    },
    component: () => import("@/views/guide/IntegrationGuidePage.vue"),
  },
];
export default mainRoutes;
